(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-to-top-button"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.querySelector('[data-scroll-to-top]');
    if (!button) return;

    const updateButton = () => {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollProgress = scrollableHeight > 0 ? window.scrollY / scrollableHeight : 0;
      button.style.setProperty('--scroll-progress', `${Math.min(scrollProgress, 1) * 360}deg`);
      button.classList.toggle('is-visible', window.scrollY > 240);
    };

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', updateButton, { passive: true });
    window.addEventListener('resize', updateButton);
    updateButton();
  })();
  } catch(e) { console.error(e); }
})();

})();
